/*
 * @Descripttion:
 * @version:
 * @Author: AowCt <awoct10@163.com>
 * @Date: 2019-10-23 09:04:20
 * @LastEditors: AowCt <awoct10@163.com>
 * @LastEditTime: 2022-07-21 11:42:09
 */
// const crypto = require('crypto');
import CryptoJS from 'crypto-js'
export function debounce (func, wait, immediate) {
  let timeout, args, context, timestamp, result
  const later = function () {
    // 据上一次触发时间间隔
    const last = +new Date() - timestamp

    // 上次被包装函数被调用时间间隔 last 小于设定时间间隔 wait
    if (last < wait && last > 0) {
      timeout = setTimeout(later, wait - last)
    } else {
      timeout = null
      // 如果设定为immediate===true，因为开始边界已经调用过了此处无需调用
      if (!immediate) {
        result = func.apply(context, args)
        if (!timeout) context = args = null
      }
    }
  }
  return function (...args) {
    context = this
    timestamp = +new Date()
    const callNow = immediate && !timeout
    // 如果延时不存在，重新设定延时
    if (!timeout) timeout = setTimeout(later, wait)
    if (callNow) {
      result = func.apply(context, args)
      context = args = null
    }

    return result
  }
}

export const getUrlParams = (url) => {
  const a = url.split('&')
  const res = {}
  for (const i of a) {
    const key = i.split('=')[0]
    const val = i.split('=')[1]
    if (key && val !== undefined) res[key] = val
  }
  return res
}

// 获取cookie
export const getCookie = (name) => {
  const arrCookie = document.cookie.split(';')
  for (let i = 0; i < arrCookie.length; i++) {
    const arr = arrCookie[i].split('=') // 从 = 的位置 分割每对cookie
    if (arr[0].replace(/(^\s*|\s*$)/g, '') === name) { // 存在此cookie
      return (arr[1] ? decodeURIComponent(arr[1]) : null) // 若值不为空，返回此值，否则返回null
    }
  }
  return null
}
// 设置cookie
export const setCookie = (name, val, time = 3 * 24 * 60 * 60 * 1000, path, domain) => {
  const exp = new Date()
  const p = path ? ';path=' + path : ';path=/'
  const d = domain ? ';domain=' + domain : ''
  exp.setTime(exp.getTime() + time) // 默认3天过期, 删除cookie传入负值即可
  document.cookie = name + '=' + encodeURIComponent(val) + ';expires=' + exp.toGMTString() + p + d
}
// 删除ookie
export const removeCookie = (name) => {
  setCookie(name, null, -1)
}
//     // 数据DES加密
export function aseEncode (word, keyStr) {
  var keyHex = CryptoJS.enc.Utf8.parse(keyStr)
  var encrypted = CryptoJS.DES.encrypt(word, keyHex, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  })
  return encrypted.ciphertext.toString()
}
// 数据DES解密
export function aseDecode (word, keyStr) {
  var keyHex = CryptoJS.enc.Utf8.parse(keyStr)
  var decrypted = CryptoJS.DES.decrypt({
    ciphertext: CryptoJS.enc.Hex.parse(word)
  }, keyHex, {
    mode: CryptoJS.mode.ECB,
    padding: CryptoJS.pad.Pkcs7
  })
  var resultValue = decrypted.toString(CryptoJS.enc.Utf8)
  return resultValue
}
export function uuid (len, radix) {
  const chars = '0123456789ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz'.split('')
  const uuid = []
  let i
  radix = radix || chars.length
  if (len) {
    // Compact form
    for (i = 0; i < len; i++) uuid[i] = chars[0 | Math.random() * radix]
  } else {
    // rfc4122, version 4 form
    let r
    // rfc4122 requires these characters
    uuid[8] = uuid[13] = uuid[18] = uuid[23] = '-'
    uuid[14] = '4'
    // Fill in random data.  At i==19 set the high bits of clock sequence as
    // per rfc4122, sec. 4.1.5
    for (i = 0; i < 36; i++) {
      if (!uuid[i]) {
        r = 0 | Math.random() * 16
        uuid[i] = chars[(i === 19) ? (r & 0x3) | 0x8 : r]
      }
    }
  }
  return uuid.join('')
}

export function getFormatDate (seperator1 = '-', type, seperator2 = ':', seperator3 = ' ') {
  var date = new Date()
  var month = date.getMonth() + 1
  var strDate = date.getDate()
  if (month >= 1 && month <= 9) {
    month = '0' + month
  }
  if (strDate >= 0 && strDate <= 9) {
    strDate = '0' + strDate
  }
  let currentdate = ''
  if (type === 'day') {
    currentdate = date.getFullYear() + seperator1 + month + seperator1 + strDate
  } else {
    currentdate = date.getFullYear() + seperator1 + month + seperator1 + strDate + seperator3 + (date.getHours() > 9 ? date.getHours() : '0' + date.getHours()) + seperator2 + (date.getMinutes() > 9 ? date.getMinutes() : '0' + date.getMinutes()) + seperator2 + (date.getSeconds() > 9 ? date.getSeconds() : '0' + date.getSeconds())
  }
  return currentdate
}

export const base64toBlob = (base64, type = 'application/octet-stream') => {
  const bstr = atob(base64)
  let n = bstr.length
  const u8arr = new Uint8Array(n)
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n)
  }
  return new Blob([u8arr], { type })
}

export const base64toBlobUrl = (base64, type = 'application/octet-stream') => {
  const blob = base64toBlob(base64, type)
  const blobUrl = URL.createObjectURL(blob)
  return blobUrl
}
